var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchGreenMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 49.513,
    viewBox: "0 0 40 49.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860",
    transform: "translate(-406 -923.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801",
    transform: "translate(-1.703 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658",
    transform: "translate(820.702 139.013)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Search",
    transform: "translate(-413 832)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search")))), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Search",
    "data-name": "Iconly/Bulk/Search",
    transform: "translate(409.241 921.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M9.5,0A9.5,9.5,0,1,1,0,9.5,9.5,9.5,0,0,1,9.5,0Z",
    transform: "translate(4.556 5)",
    fill: "#00ff5f",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search-2",
    "data-name": "Search",
    transform: "translate(2.759 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-2177.34,52.117a11.749,11.749,0,0,1-8.389-3.5,11.9,11.9,0,0,1-3.475-8.442,11.9,11.9,0,0,1,3.475-8.441,11.749,11.749,0,0,1,8.389-3.5,11.749,11.749,0,0,1,8.389,3.5,11.9,11.9,0,0,1,3.475,8.441,11.9,11.9,0,0,1-3.475,8.442A11.749,11.749,0,0,1-2177.34,52.117Zm-.068-20.136a8.509,8.509,0,0,0-8.5,8.5,8.51,8.51,0,0,0,8.5,8.5,8.51,8.51,0,0,0,8.5-8.5A8.51,8.51,0,0,0-2177.408,31.982Z",
    transform: "translate(2189.204 -28.241)",
    fill: "#00ff5f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34202",
    d: "M4.522,6.314A1.823,1.823,0,0,1,3.3,5.783L.486,2.5A1.5,1.5,0,0,1,.376.4h0A1.344,1.344,0,0,1,2.29.4L5.823,3.228a1.86,1.86,0,0,1,.4,1.974A1.841,1.841,0,0,1,4.6,6.376Z",
    transform: "translate(21.242 21.217)",
    fill: "#00ff5f",
    opacity: 0.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreenMobile);
export default __webpack_public_path__ + "static/media/search-green-mobile.b40b8642fd56c0f2f616e7373150516c.svg";
export { ForwardRef as ReactComponent };